exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-gops.js
 ** module id = 43
 ** module chunks = 1
 **/